import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as display from '../../../display'
import type { Api } from '../api'
import type { Collection } from '../collection'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/** Child feature that owns document-operation state for one collection. */
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor(collection: Collection, api: Api) {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'FileOperations',
      parent: collection.feature,
      selectors: () => new Selectors(this, collection),
    })

    const toasterFeature = ngCore.inject(display.toaster.Feature)
    this.registerEffects(
      effects.confirmDelete(),
      effects.executeDownload(api),
      effects.openDownload(),
      effects.showDownloadError(toasterFeature),
      effects.executeDelete(api),
      effects.handleDeleteSuccess(toasterFeature),
      effects.executeUpload(api),
      effects.handleUploadSuccess(toasterFeature),
      effects.showUploadError(toasterFeature),
    )
  }
}
